import React from 'react';
import './PopupStyles.css';
import { useContent } from '../hooks/useContent';

const ConsentPopup = ({ hasLanguageSelected }) => {
  const content = useContent('consent');
  
  if (!content) return null; // Handle case when content is not available

  return (
    <div className={`consent-overlay ${!hasLanguageSelected ? 'disabled-overlay' : ''}`}>
      <div className="consent-content">
        <div className="consent-content-inner">
          {/*COMMENTED OUT BELOW FOR STREAMINED APP VERSION*/}
          {/*
          <h2>{content.title}</h2>
          <div className="consent-text">
            <p>{content.subtitle}</p>
            <ul>
              {content.bulletPoints.map((point, index) => (
                <li key={index}>
                  <strong>{point.title}</strong> {point.text}
                </li>
              ))}
            </ul>
            <p>
              {content.links.prefix}{' '}
              <a href="https://tell-me.ai/privacy" target="_blank" rel="noopener noreferrer">
                {content.links.privacy}
              </a>
              {' '}{content.links.connector}{' '}
              <a href="https://tell-me.ai/terms" target="_blank" rel="noopener noreferrer">
                {content.links.terms}
              </a>.
            </p>
          </div>
          */}
          <div
            style={{
              width: "90%",           // Makes the logo take up 90% of the available width
              maxWidth: "700px",      // Optional: prevents it from being too huge on big screens
              margin: "60px auto 0",  // Top margin, centered horizontally
              display: "flex",
              justifyContent: "center"
            }}
          >
            <img
              src="/Tellme_Vertical_Logo_vlarge-05.2025_compressed.png"
              alt="Tellme Logo"
              style={{
                width: "100%",        // Fills the container width
                height: "auto",       // Maintains aspect ratio
                display: "block"
              }}
            />
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ConsentPopup;